import { serviceOptions } from './services';
import axios from 'axios';
export * from './services';

serviceOptions.axios = axios.create({ baseURL: process.env.REACT_APP_API_URL });
